import React from "react"
import { Alert, Descriptions, Spin, Table, Tag, Typography } from "antd"
import { STAGES, STATUSES, STEP_STATUSES, formatDateTime, formatDuration, formatError } from "./labels"

// Все этапы процесса входа по порядку: строка — этап, запросы отделены заголовком.
function cascadeRows(process) {
  const rows = []
  process.requests.forEach((request, index) => {
    rows.push({ key: `r${request.id}`, isRequest: true, index: index + 1, request })
    request.steps.forEach((step) => rows.push({ key: `s${step.id}`, step }))
  })

  return rows
}

const columns = [
  {
    title: "Этап каскада",
    render: (_, row) => {
      if (row.isRequest) {
        const status = STATUSES[row.request.status]
        return {
          children: (
            <Typography.Text strong>
              Запрос {row.index} · {formatDateTime(row.request.startedAt)} ·{" "}
              <Tag color={status?.color}>{status?.label ?? row.request.status}</Tag>
              {row.request.steps.length === 0 && <Typography.Text type="secondary">этапов нет</Typography.Text>}
            </Typography.Text>
          ),
          props: { colSpan: 5 },
        }
      }
      const stage = STAGES[row.step.stage]
      return <Tag color={stage?.color}>{stage?.label ?? row.step.stage}</Tag>
    },
  },
  {
    title: "Статус этапа",
    render: (_, row) => {
      if (row.isRequest) return { props: { colSpan: 0 } }
      const status = STEP_STATUSES[row.step.status]
      return <Tag color={status?.color}>{status?.label ?? row.step.status}</Tag>
    },
  },
  {
    title: "Причина ошибки",
    render: (_, row) => (row.isRequest ? { props: { colSpan: 0 } } : formatError(row.step.error) ?? "—"),
  },
  {
    title: "Попыток ввода кода",
    align: "right",
    render: (_, row) => (row.isRequest ? { props: { colSpan: 0 } } : row.step.attempts || "—"),
  },
  {
    title: "Время выполнения",
    align: "right",
    render: (_, row) => (row.isRequest ? { props: { colSpan: 0 } } : formatDuration(row.step.durationMs)),
  },
]

// Раскрытая строка журнала: весь процесс входа номера — от первого запроса до итога.
export function ProcessCascade({ processId, loadProcess }) {
  const [process, setProcess] = React.useState(null)
  const [error, setError] = React.useState(null)

  React.useEffect(() => {
    let cancelled = false
    loadProcess(processId)
      .then((data) => !cancelled && setProcess(data))
      .catch(() => !cancelled && setError("Не удалось загрузить процесс входа"))

    return () => {
      cancelled = true
    }
  }, [processId])

  if (error) return <Alert type="error" message={error} />
  if (!process) return <Spin />

  const finalMethod = STAGES[process.finalMethod]
  const status = STATUSES[process.status]

  return (
    <div style={{ padding: "4px 0" }}>
      <Descriptions size="small" column={{ xs: 1, md: 4 }} style={{ marginBottom: 8 }}>
        <Descriptions.Item label="Итог">
          <Tag color={status?.color}>{status?.label ?? process.status}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Итоговый способ входа">
          {finalMethod ? <Tag color={finalMethod.color}>{finalMethod.label}</Tag> : "—"}
        </Descriptions.Item>
        <Descriptions.Item label="Запросов / этапов">
          {process.requestsCount} / {process.stepsCount}
        </Descriptions.Item>
        <Descriptions.Item label="Длительность входа">{formatDuration(process.durationMs)}</Descriptions.Item>
      </Descriptions>
      <Table size="small" pagination={false} dataSource={cascadeRows(process)} columns={columns} />
    </div>
  )
}
